import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import brandPortalOrdersbrandOrderTokenEdit from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/edit";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var AddOrEditItemsIA = function AddOrEditItemsIA(_ref) {
  var _context$brandOrder, _context$brandOrder$b;
  var context = _ref.context;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (brandOrderToken) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "7fDMID",
      defaultMessage: [{
        "type": 0,
        "value": "Para adicionar ou editar produtos numa encomenda, aceda primeiro à "
      }, {
        "children": [{
          "type": 0,
          "value": "página de detalhes da encomenda"
        }],
        "type": 8,
        "value": "OrderDetailsLinkFormatting"
      }, {
        "type": 0,
        "value": ". Em seguida, selecione "
      }, {
        "children": [{
          "type": 0,
          "value": "Editar encomenda"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return EditOrderLinkFormatting(chunks, brandOrderToken);
        },
        OrderDetailsLinkFormatting: function OrderDetailsLinkFormatting(chunks) {
          return orderDetailsLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "ab3w4/",
      defaultMessage: [{
        "type": 0,
        "value": "Pode adicionar produtos clicando no botão "
      }, {
        "children": [{
          "type": 0,
          "value": "Adicionar produto"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " e removê-los clicando no ícone do Caixote de lixo junto de cada artigo. Pode atualizar as quantidades de artigos alterando o número na coluna "
      }, {
        "children": [{
          "type": 0,
          "value": "Qtd."
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "UjBG6x",
      defaultMessage: [{
        "type": 0,
        "value": "Após efetuar as alterações, clique em "
      }, {
        "children": [{
          "type": 0,
          "value": "Atualizar"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " para as guardar. Terá também a opção de deixar uma nota ao revendedor, o que recomendamos vivamente para que este saiba o que se passa com a encomenda. O revendedor receberá uma notificação por e-mail com os detalhes das alterações."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Sdx3lz",
      defaultMessage: [{
        "type": 0,
        "value": "Para adicionar ou editar produtos numa encomenda, aceda primeiro às suas "
      }, {
        "children": [{
          "type": 0,
          "value": "Encomendas"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " e navegue para a "
      }, {
        "children": [{
          "type": 0,
          "value": "página de detalhes da encomenda"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " que pretende alterar. Em seguida, selecione "
      }, {
        "children": [{
          "type": 0,
          "value": "Editar encomenda"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Un5qc8",
      defaultMessage: [{
        "type": 0,
        "value": "Pode adicionar produtos clicando no botão "
      }, {
        "children": [{
          "type": 0,
          "value": "Adicionar produto"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " e removê-los clicando no ícone do Caixote de lixo junto de cada artigo. Pode atualizar as quantidades de artigos alterando o número na coluna "
      }, {
        "children": [{
          "type": 0,
          "value": "Qtd."
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "lyNjZ+",
      defaultMessage: [{
        "type": 0,
        "value": "Após efetuar as alterações, clique em "
      }, {
        "children": [{
          "type": 0,
          "value": "Atualizar"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " para as guardar. Terá também a opção de deixar uma nota ao revendedor, o que recomendamos vivamente para que este saiba o que se passa com a encomenda. O revendedor receberá uma notificação por e-mail com os detalhes das alterações."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  }
};
var EditOrderLinkFormatting = function EditOrderLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenEdit(brandOrderToken),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var orderDetailsLinkFormatting = function orderDetailsLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};